<template>
  <div class="nots mx-1" style="position: relative">
    <span>
      <router-link
        class="px-1"
        to="/dashboard/admin/notificacoes"
        title="Notificações"
      >
        <div :class="nots > 0? 'animate__animated animate__tada animate__infinite': ''">
          <i class="mdi mdi-bell mdi-24px text-white"> </i>
        </div>
        <span v-if="nots > 0" class="badge badge-light badge-danger text-white">
          {{ nots }}
        </span>
      </router-link>
    </span>
    <chat-app v-if="showChat" />
    <post-app />
  </div>
</template>

<script>
import socket from "@/dashboard/socket";
export default {
  data() {
    return {
      urlbase: `${window.location.protocol}//${window.location.host}`,
      showChat: true,
    };
  },
  updated() {
    this.checkShowButtonChat();
    this.connect();
  },
  mounted() {
    this.checkShowButtonChat();

    this.$store.dispatch("loadNots");
    let userID = this.$store.state.user.id;
    let username = this.$store.state.user.name;
    socket.auth = { userID, username };
    socket.userID = userID;
    socket.connect();
    socket.emit("set user logado", this.$store.state.user, this.urlbase);

    socket.on("user.notification", (notification) => {
      if (notification == "'Você recebeu uma mensagem'")
        this.$store.commit("ADD_MESSAGE_NUMBER");
      else this.$store.commit("ADD_NOTIFICATION", notification);
      // console.log("Notificação recebida", this.$store.state.messages);
      swal.fire({
        title: `<span="d-flex align-items-center"><i class="mdi mdi-bell mdi-24px animate__animated animate__tada animate__infinite"> </i>  TEM NOVIDADE PARA VOCÊ</span>`,
        html: notification,
        toast: true,
        position: "top-right",
        timer: 6000,
        showConfirmButton: false,
        timerProgressBar: true,
      });
      this.start();
    });
  },
  computed: {
    nots() {
      return this.$store.state.notifications.length;
    },
  },
  watch: {
    $route() {
      this.checkShowButtonChat();
    },
  },
  methods: {
    connect() {},
    checkShowButtonChat() {
      if (
        this.$route.path == "/dashboard/chat" ||
        this.$route.path == "/dashboard/demandas" ||
        this.$route.path == "/dashboard/suportes"
      ) {
        this.showChat = false;
      } else {
        this.showChat = true;
      }
    },
    start() {
      var context;
      var oscillator;
      var contextGain;

      context = new AudioContext();
      oscillator = context.createOscillator();
      contextGain = context.createGain();

      oscillator.connect(contextGain);
      contextGain.connect(context.destination);
      oscillator.start(0);

      contextGain.gain.exponentialRampToValueAtTime(
        0.00001,
        context.currentTime + 5
      );
    },
  },
};
</script>

<style>
.nots .badge {
  position: absolute;
  top: 9px;
  right: -6px;
  text-align: center;
  font-size: 9px;
  padding: 5px;
  line-height: 0.9;
}
</style>
